import api from "./Api";

class EmitenteTipoUsuarioService {
  GetEmitenteTipoUsuario(payload) {
    return api.get("/v1/emitenteTipoUsuario/" + payload).then((response) => {
      return response.data;
    });
  }

  PostEmitenteTipoUsuario(payload) {
    return api.post("/v1/emitenteTipoUsuario/", payload).then((response) => {
      return response.data;
    });
  }

  PutEmitenteTipoUsuario(payload) {
    return api.put("/v1/emitenteTipoUsuario/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteEmitenteTipoUsuario(payload) {
    return api.delete("/v1/emitenteTipoUsuario/" + payload).then((response) => {
      return response.data;
    });
  }

  GetEmitenteTipoUsuarioOData(payload) {
    return api.get("/OData/EmitenteTipoUsuario" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new EmitenteTipoUsuarioService();
